// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"f5a54eb2","146":"d432edb0","556":"6c106c3e","746":"b3f96a32","779":"f0451377"}[chunkId] + ".chunk.css";
};